import { render, staticRenderFns } from "./edit-options-modal.vue?vue&type=template&id=13b03bf8&"
import script from "./edit-options-modal.vue?vue&type=script&lang=ts&"
export * from "./edit-options-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports